var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('preloader'),_c('h2',[_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.back))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" Timed Test.")],1),_c('h1',[_vm._v("Coming soon")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }